import TxpDateTimeCallbacks from 'txp-data/lib/schema/configSchema/TxpDateTimeCallbacks';
import getDisplayDateData from './getDisplayDateData';
import { utcDate, userDate, isAfter, isSameDay, now } from 'owa-datetime';
import tryCreateTxpOwaDate from './tryCreateTxpOwaDate';
import tryCreateTxpUtcDate from './tryCreateTxpUtcDate';
import Entity from 'txp-data/lib/schema/Entity';

export function populateOwaDateTimeCallbacks(): TxpDateTimeCallbacks {
    return {
        isFutureTime: isFutureTimeTxp,
        isSameDay: isSameDayTxp,
        getDisplayDateData: getDisplayDateData,
        isValidDate: isValidOwaDate,
    };
}

function isFutureTimeTxp(dateTime: string): boolean {
    const departureTime = utcDate(dateTime);
    const currentTime = utcDate(now());
    return isAfter(departureTime, currentTime);
}

function isSameDayTxp(startTime: string, endTime: string): boolean {
    const earliestDeliveryDate = userDate(startTime);
    const latestDeliveryDate = userDate(endTime);
    return isSameDay(earliestDeliveryDate, latestDeliveryDate);
}

function isValidOwaDate(dateTime: string, isUtcTime: boolean, entity: Entity): boolean {
    if (isUtcTime) {
        return tryCreateTxpUtcDate(dateTime, entity);
    } else {
        return tryCreateTxpOwaDate(dateTime, entity);
    }
}
